import React from 'react';
import { Classes } from '../index';
export const TestEnvironmentBar = () => {
  return (
    <div
      title={'Aplikace je spuštěna v testovacím prostředí.'}
      className={Classes.TEST_ENVIRONMENT_BAR}
    >
      TST
    </div>
  );
};
